<template>
  <div class="dd-video-item">
    <div class="dd-video-item__bd">
      <video class="dd-video-item__video" ref="video" controls autoplay :src="data.video" v-if="showVideo">
      </video>
      <div 
        v-show="!showVideo"
        class="dd-video-item__cover" 
        :style="style"
        @click="handleClick">
        <span class="dd-video-item__btn">
          <Icon type="play"/>
        </span>
      </div>
    </div>
    <div class="dd-video-item__ft">
      <h5 class="dd-video-item__title">{{data.title}}</h5>
      {{data.duration}}
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
const eventBus = new Vue()

export default {
  props: {
    data: {
      type: Object,
      default: () => ({})
    }
  },
  data () {
    return {
      showVideo: false
    }
  },
  computed: {
    style () {
      return {
        backgroundImage: `url(${this.data.poster})`
      }
    }
  },
  mounted () {
    eventBus.$on('play', () => {
      this.showVideo = false
    })
  },
  methods: {
    handleClick () {
      eventBus.$emit('play')
      this.showVideo = true
      this.$nextTick(() => {
        this.$refs.video.play()
      })
    }
  }
}
</script>

<style lang="scss">
.dd-video-item {
  display: inline-block;
  width: 390px;

  $btn: #{&}__btn;

  &__bd {
    position: relative;
    z-index: 0;
    height: 560px;
    background: #191919;
  }
  &__video,
  &__cover {
    width: 100%;
    height: 100%;
  }
  &__cover {
    position: relative;
    background: #eee no-repeat center;
    background-size: cover;
    cursor: pointer;
  
    &:after {
      content: "";
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background: rgba(0,0,0, .5);
      transition: all .3s;
    }
    &:hover {
      &:after {
        // background: transparent;
      }
      #{$btn} {
        opacity: 1;
      }
    }
  }
  &__video {
    &:focus {
      outline: none;
    }
  }
  #{$btn} {
    position: absolute;
    z-index: 1;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    width: 71px;
    height: 71px;
    line-height: 71px;
    border-radius: 71px;
    text-align: center;
    background: #fff;
    opacity: 0;
    transition: all .3s;
    color: #6F98FF;
  }
  &__ft {
    padding: 27px 0;
    text-align: left;
    font-size: 18px;
    color: #ccc;
    border-bottom: 1px solid #666;
  }
  &__title {
    font-size: 21px;
    margin-bottom: 14px;
  }
  @include media-tablet {
    display: block;
    max-width: 390px;
    width: auto;

    &__bd {
      position: relative;
      padding: percentage(560px / 390px) 0 0;
      top: 0;
      left: 0;
      height: 0;
    }
    &__video,
    &__cover {
      position: absolute;
      left: 0;
      top: 0;
    }
    &__ft {
      font-size: 11px;
    }
    &__title {
      font-size: 13px;
      margin-bottom: 14px;
    }
  }
}
</style>
